<template>
  <span class="d-inline-flex align-items-center">
    <span v-b-modal="modalId" class="pointer">
      <mdicon name="information-outline" size="16" class="text-muted" />
    </span>
    <b-modal :id="modalId" no-footer centered>
      <template #title>
        <span class="h5 font-weight-bold">{{ title }}</span>
      </template>
      <div class="info-modal-body">
        <slot />
      </div>
    </b-modal>
  </span>
</template>

<script lang="ts">
import { BModal } from 'bootstrap-vue-next'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InfoModalTrigger',
  components: { BModal },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    const modalId = `info-modal-${Math.random().toString(36).slice(2, 10)}`

    return {
      modalId,
    }
  },
})
</script>
